import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { BOOK_TITLE } from '../../lib/constants';

export function CheckoutSuccess() {
  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-4">
      <motion.div
        className="max-w-md w-full text-center"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Success checkmark */}
        <motion.div
          className="w-20 h-20 rounded-full bg-sage/10 flex items-center justify-center mx-auto mb-8"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
        >
          <svg aria-hidden="true" className="w-10 h-10 text-sage" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
        </motion.div>

        <h1 className="font-serif text-3xl font-bold text-text mb-4">
          Thank You!
        </h1>
        <p className="text-text-light text-lg mb-2">
          Your purchase of <strong className="text-text">{BOOK_TITLE}</strong> is confirmed.
        </p>
        <p className="text-text-light mb-8">
          Check your email for your download link. It should arrive within a few minutes.
        </p>

        <div className="bg-white rounded-xl border border-sage/10 p-6 mb-8">
          <h3 className="font-serif font-semibold text-text mb-3">What's next?</h3>
          <ul className="text-sm text-text-light space-y-2 text-left">
            <li className="flex items-start gap-2">
              <svg aria-hidden="true" className="w-4 h-4 text-sage flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Check your inbox (and spam folder) for the download email
            </li>
            <li className="flex items-start gap-2">
              <svg aria-hidden="true" className="w-4 h-4 text-sage flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Click the download link within 72 hours
            </li>
            <li className="flex items-start gap-2">
              <svg aria-hidden="true" className="w-4 h-4 text-sage flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Start mastering your money!
            </li>
          </ul>
        </div>

        <Link
          to="/"
          className="text-sage-dark hover:text-sage font-medium transition-colors"
        >
          &larr; Back to home
        </Link>
      </motion.div>
    </div>
  );
}
